import { Form, SubmitFormButton } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Popup, Body, Footer } from '@calendly/ui/components/popup';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { changePopupData, confirmPopup, dismissPopup, changePopupLocation, clearPotentialKind } from '../actions';
import { LocationSelect } from '../location_select';
import { popupSelector, availableLocationKindsSelector, dividedAvailableLocationKindsSelector, useNewDropdownSelector } from '../selectors';
import { useStateValue, useDispatchValue } from '../state_provider';
const locationSelectFieldCss = "l9317sc";
const LocationSelectField = forwardRef((props, ref) => <LocationSelect ref={ref} {...props} className={classNames(locationSelectFieldCss, props.className)} />);
export const GeneralPopup = ({
  initialValues = {},
  validationSchema,
  children
}) => {
  const state = useStateValue();
  const dispatch = useDispatchValue();
  const useNewDropdown = useNewDropdownSelector(state);
  const availableKinds = useNewDropdown ? dividedAvailableLocationKindsSelector(state) : availableLocationKindsSelector(state);
  const {
    data: {
      kind
    }
  } = popupSelector(state);
  const handleSelectChange = useCallback(newKind => {
    dispatch(changePopupLocation(newKind));
  }, [dispatch]);
  const handleDismiss = useCallback(() => {
    dispatch(dismissPopup());
    dispatch(clearPotentialKind());
  }, [dispatch]);
  const handleSubmit = useCallback(({
    location,
    phoneNumber,
    additionalInfo,
    hideLocation,
    kind: selectedKind
  }) => {
    const values = {
      kind: selectedKind || kind,
      location: null,
      phone_number: null,
      additional_info: null,
      hide_location: false
    };
    if (values.kind === 'physical') {
      values.location = location;
      values.additional_info = additionalInfo;
    }
    if (values.kind === 'inbound_call') {
      values.additional_info = additionalInfo;
      values.phone_number = phoneNumber;
    }
    if (values.kind === 'custom') {
      values.location = location;
      values.hide_location = hideLocation === 'hidden';
    }
    dispatch(changePopupData(values));
    dispatch(confirmPopup());
    dispatch(clearPotentialKind());
  }, [dispatch, kind]);
  return <Popup onClose={handleDismiss} title={I18n.t('publisher.event_types.location.edit_location')}>
      <Form initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
        <Body>
          <LocationSelectField aria-label={I18n.t('publisher.event_types.location.location')} onChange={handleSelectChange} kind={kind} availableKinds={availableKinds} autoFocus={false} />
          {children}
        </Body>
        <Footer>
          <Button decoration="secondary-outline" onClick={handleDismiss}>
            {I18n.t('publisher.action.cancel')}
          </Button>
          <SubmitFormButton>
            {I18n.t('publisher.action.update')}
          </SubmitFormButton>
        </Footer>
      </Form>
    </Popup>;
};

require("./general_popup.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./general_popup.js");